// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2OnGZ","title":"Images90_title__3WCma","images":"Images90_images__1zdIS"};